import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '@environment';
import {LoadingService} from '@portal-commons/providers/loading.service';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Do not show loader when requesting session info
    if (
      req.url === environment.endpoints.getUnreadMessagesCount ||
      req.url === environment.endpoints.getPostboxMessages ||
      req.url === environment.endpoints.logError ||
      req.url.indexOf(environment.endpoints.getStreetsForPostalCodeAndCity) > -1 ||
      req.url.indexOf(environment.endpoints.getCityForPostalCode) > -1 ||
      req.url.indexOf('/onlinedeal') > -1
    ) {
      return next.handle(req);
    }

    this.loadingService.startLoading();

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => throwError(error)),
      finalize(() => this.loadingService.stopLoading()),
    );
  }
}
